// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__36T-S","rootSuccess":"CompleteLink_rootSuccess__3rq-7","rootFailure":"CompleteLink_rootFailure__3Rd2J","isDisabled":"CompleteLink_isDisabled__32i7F"};